module.exports = __webpack_public_path__ + "img/icon-dots.5be1f83e.svg";